import { inject } from "mobx-react";

import { DateDisplay } from "../../../../core/components/DateDisplay.component";
import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import type { FeedResultFragment } from "@ihr-radioedit/inferno-webapi";
import { trimText } from "../../../../core/lib/utilities";
import { formatImage } from "@ihr-radioedit/inferno-core";
import { MagicLink } from "../../../../core/ui";
import { CoastFeedItemType, getCoastFeedImg } from "../../lib/coastFeed";
import { RESPONSIVE_IMAGE, DATETIME_DISPLAY_FORMATS, isPublishRecord } from "@inferno/renderer-shared-core";
import type { Store } from "@inferno/renderer-shared-core";

interface CoastFeedInTheNewsItemProps {
  item: FeedResultFragment;
  store?: Store;
}

export const CoastFeedInTheNewsItem = inject("store")(({ item, store }: CoastFeedInTheNewsItemProps) => {
  if (
    !store ||
    !isPublishRecord(item.record) ||
    !item.record.payload.fields?.source?.value ||
    !item.record.payload.fields?.source_url?.value
  ) {
    return null;
  }

  const { slug, payload, pub_start } = item.record;
  const { summary } = payload;

  const altText = summary.image.alt_text || summary.title;
  const thumb = formatImage(summary.image.url, store.env.IMAGE_HOST);
  const articleUrl = payload.fields.source_url.value;
  const { imgSrc, srcset } = getCoastFeedImg(thumb, CoastFeedItemType.IN_THE_NEWS, { quality: 80 });

  return (
    <div className="coast-feed-item">
      <figure className="item-thumb">
        <MagicLink to={articleUrl} external={true} context={slug}>
          <ResponsiveImage
            src={imgSrc}
            srcset={srcset}
            alt={altText}
            initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
            initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
          />
        </MagicLink>
      </figure>

      <MagicLink className="item-title" to={articleUrl} external={true} context={slug}>
        {summary.title}
      </MagicLink>
      <DateDisplay
        datetime={pub_start}
        className="item-published"
        dateFormat={DATETIME_DISPLAY_FORMATS.SHORT_MONTH_DAY_FULL_YEAR}
      />
      <section className="item-summary">
        <span>{trimText(summary.description, 250)}</span>
        <span>
          <em>&#8212;&nbsp;{payload.fields.source.value}</em>
        </span>
      </section>
    </div>
  );
});
